module.exports = __webpack_public_path__ + "img/index-route-bg.b13f17e3.jpg";